<template>
    <notifications group="base">
        <template #body="props">
            <div class=" p-4 rounded bg-white m-1 border-l-error border-l-8 border-solid shadow-1 relative">
                <div class="pr-5">
                    <!-- <p class="text-lg text-gray-900 font-bold break-all">
                        {{ props.item.title }}
                    </p> -->
                    <div
                        class="text-base text-gray-700  break-all"
                        v-html="props.item.text"
                    />
                </div>

                <button
                    class="btn btn-circle btn-ghost absolute right-0 top-0"
                    @click="props.close"
                >
                    <SvgIcon
                        icon-name="close"
                        class="text-gray-400 w-6 h-6 cursor-pointer"
                    />
                </button>
            </div>
        </template>
    </notifications>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
// 沒有用到
.notification {
    @apply rounded mx-3 my-1 px-3 py-5 shadow-1 border-l-primary border-l-8 border-r-8 border-solid;
    .notification-title {
        @apply font-bold text-lg break-words text-gray-800;
    }
    .notification-content {
        @apply text-sm break-words text-gray-600;
    }
    &.success {
        @apply border-l-secondary;
    }
    &.warn {
        @apply border-l-warning;
    }
    &.error {
        @apply border-l-error border-r-gray-100;
    }
}
</style>
